export default "__VITE_ASSET__DjdpEoEN__"